export default {"src":"/_next/static/media/initial-consultation.e29abf8b.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};